import {identity} from '@packages/utilities/fp/utils';
import {type Json, matchJson, set} from '@packages/utilities/json';

const reifyElementTypeDataToObject: (arg1: Json) => Json = matchJson({
  Null: identity,
  Boolean: identity,
  Number: identity,
  String: identity,
  Array: identity,
  Object: (obj) => {
    const {data} = obj;
    if (
      data &&
      // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'string | number | true | Json[] | { [key: string]: Json; }'.
      data.type === 'Typed' &&
      // @ts-expect-error - TS2339 - Property 'val' does not exist on type 'string | number | true | Json[] | { [key: string]: Json; }'.
      data.val &&
      // @ts-expect-error - TS2339 - Property 'val' does not exist on type 'string | number | true | Json[] | { [key: string]: Json; }'.
      typeof data.val.type === 'string'
    ) {
      // @ts-expect-error - TS2339 - Property 'val' does not exist on type 'string | number | true | Json[] | { [key: string]: Json; }'.
      return set(obj, ['data', 'val', 'type'], JSON.parse(data.val.type));
    }
    return obj;
  },
});

// Needed because we store Types in Mongo as a string to get around BSON nesting limit
// This function looks inside of a given expression JSON for Element types, then looks
// if they have Typed data, and if it's a string, turns it into an object
export const reifyElementTypeInExpressionJson: (arg1: Json) => Json = matchJson(
  {
    Null: identity,
    Boolean: identity,
    // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: number) => boolean | null'.
    Number: identity,
    // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: string) => boolean | null'.
    String: identity,
    // @ts-expect-error - TS2322 - Type '<A>(x: A) => A' is not assignable to type '(arg1: Json[]) => boolean | null'.
    Array: identity,
    // @ts-expect-error - TS2322 - Type '(obj: { [key: string]: Json; }) => { [key: string]: Json; }' is not assignable to type '(arg1: { [key: string]: Json; }) => boolean | null'.
    Object: (obj) => {
      const {type, val} = obj;
      if (type === 'Element') {
        // @ts-expect-error - TS2345 - Argument of type 'Json | undefined' is not assignable to parameter of type 'Json'.
        const reifiedVal = reifyElementTypeDataToObject(val);
        return val === reifiedVal ? obj : {type, val: reifiedVal};
      }
      return obj;
    },
  }
);
